export const setupLeftMenu = () => {
  // jesli ma sub ul to dodajmy klase
  var leftMenu = $(".left-menu");
  leftMenu
    .find("ul.lvl-1")
    .parent()
    .addClass("has-sub-ul");
};
